import { dynamic } from './dynamic';
import { setPriority } from './priority';
import { Priority } from './constants';
import { isEventProperty } from '../util';
import { getActiveViewRevision } from './util';
const propertySymbols = new Map();
function getPropertySymbol(property) {
    const existing = propertySymbols.get(property);
    if (existing) {
        return existing;
    }
    const symbol = Symbol(property);
    propertySymbols.set(property, symbol);
    return symbol;
}
function createListProcessor({ flatten, merge }) {
    return function listPropertyProcessor(value, revision, property) {
        const symbol = getPropertySymbol(property);
        // Initialize list state for current revision
        if (!(symbol in revision)) {
            revision[symbol] = {
                list: [],
                merged: []
            };
        }
        const committedRevision = revision.instance.committedRevision;
        const committed = committedRevision === null || committedRevision === void 0 ? void 0 : committedRevision[symbol];
        const current = revision[symbol];
        // Ensure the current prop value matches the latest merged value; otherwise
        // treat the current prop value as the first value to merge.
        const propValue = revision.props[property];
        if (propValue !== current.merged[current.merged.length - 1]) {
            // TODO(koop): Probably need to create a new array here bc `flatten`
            // receives a length that may become inaccurate
            current.list.length = 0;
            current.merged.length = 0;
            current.list.push(propValue);
            current.merged.push(propValue);
        }
        const index = current.list.length;
        // Add the value to the current state
        current.list.push(value);
        let mergedValue = value;
        if (index === 0) {
        // nothing to merge; use the existing value
        } else if (// Check if we can reuse the committed merged value
        committed && // Is the value we're adding the same?
        committed.list[index] === value && // Is the merged output up to this value the same?
        committed.merged[index - 1] === current.merged[index - 1]) {
            mergedValue = committed.merged[index];
        } else if (flatten) {
            mergedValue = flatten(current.list, current.list.length);
        } else if (merge) {
            mergedValue = merge(value, current.merged[index - 1]);
        }
        current.merged.push(mergedValue);
        revision.props[property] = current.merged[index];
    };
}
export const setEvent = createListProcessor({
    flatten (listeners, length) {
        return function mergedEvent(event) {
            for(let i = 0; i < length; i++){
                var _listeners_i;
                (_listeners_i = listeners[i]) === null || _listeners_i === void 0 ? void 0 : _listeners_i.call(listeners, event);
            }
        };
    }
});
export const setRef = createListProcessor({
    flatten (refs, length) {
        let currentValue = null;
        const ref = (value)=>{
            currentValue = value;
            for(let i = 0; i < length; i++){
                const ref = refs[i];
                if (ref) {
                    if (typeof ref === 'function') {
                        ref(value);
                    } else {
                        ref.current = value;
                    }
                }
            }
        };
        // Define `ref.current` to support `props.ref.current`
        // TODO(koop): Remove this once we've fully migrated to `props.inherits`
        Object.defineProperty(ref, 'current', {
            get () {
                return currentValue;
            }
        });
        return ref;
    }
});
export const setStyle = createListProcessor({
    merge (value, previousValue) {
        return Object.assign({}, previousValue, value);
    }
});
const processors = {
    default (value, revision, property) {
        if (isEventProperty(property)) {
            setEvent(value, revision, property);
        } else {
            revision.props[property] = value;
        }
    },
    className (value, revision) {
        revision.props.className = revision.props.className ? `${revision.props.className} ${value}` : value;
    },
    ref: setRef,
    style: setStyle
};
export function assignProps(source) {
    return setPriority(Priority.High, dynamic((props)=>{
        const revision = getActiveViewRevision();
        const properties = typeof source === 'function' ? source(props) : source;
        const propertyNames = Object.keys(properties);
        for(let i = 0; i < propertyNames.length; i++){
            const property = propertyNames[i];
            const processor = processors[property] || processors.default;
            processor(properties[property], revision, property);
        }
    }));
}

//# sourceMappingURL=assignProps.js.map